import request from '../../axios';

const getPromotedRequirement = async (guid?: string) => {
  const {data}: {data: PromotedAdvertisementData} = await request.get(
    `api/v2/wanted/promoted-Requirement/${guid}`,
  );
  return data;
};

export default getPromotedRequirement;
